// extracted by mini-css-extract-plugin
export default {"sub-header":"AnnexStepValidation_sub-header_bQJfL","annexes-wrapper":"AnnexStepValidation_annexes-wrapper_mkJzU","buttons-wrapper":"AnnexStepValidation_buttons-wrapper_F0CsU"};